import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { setTimeoutIfPossible } from "@faire/retailer-visitor-shared/lib/async-functions/setTimeoutIfPossible";
import { exhaustiveSwitchWithDefault } from "@faire/web--source/common/exhaustiveSwitchWithDefault";
import { getWindow } from "@faire/web--source/common/globals/getWindow";
import { Storage } from "@faire/web--source/common/Storage";
import { useState, useCallback, useEffect } from "react";
//                                    (scroll + delay)
//                                    ┌──────────────┐
//                                    │              │
// PRE_AUTO_SIGNUP──►POST_AUTO_SIGNUP─┤              ├─►DISPLAYABLE──►DISMISSED
//                                    │              │
//                                    └──────────────┘
//                                      (page load)
export var SignUpSnackbarState;
(function(SignUpSnackbarState) {
    SignUpSnackbarState["PRE_AUTO_SIGNUP"] = "pre_auto_signup";
    SignUpSnackbarState["POST_AUTO_SIGNUP"] = "post_auto_signup";
    SignUpSnackbarState["DISPLAYABLE"] = "displayable";
    SignUpSnackbarState["DISMISSED"] = "dismissed";
})(SignUpSnackbarState || (SignUpSnackbarState = {}));
export var SignUpSnackbarEvent;
(function(SignUpSnackbarEvent) {
    SignUpSnackbarEvent["AUTO_SIGNUP_OPENED"] = "auto_signup_opened";
    SignUpSnackbarEvent["AUTO_SIGNUP_CLOSED"] = "auto_signup_closed";
    SignUpSnackbarEvent["TIMEOUT_ELAPSED"] = "timeout_elapsed";
    SignUpSnackbarEvent["NAVIGATED"] = "navigated";
    SignUpSnackbarEvent["DISMISSED"] = "dismissed";
})(SignUpSnackbarEvent || (SignUpSnackbarEvent = {}));
export var LOGGED_OUT_SIGN_UP_SNACKBAR_STATE = "logged_out_sign_up_snackbar_state";
var TIME_UNTIL_DISPLAY = 2000;
// TODO(quinlan): if expirement is successful, move this away from session storage, and into to a context store
var getStateFromStorage = function() {
    return Storage.session.getItem(LOGGED_OUT_SIGN_UP_SNACKBAR_STATE) || SignUpSnackbarState.PRE_AUTO_SIGNUP;
};
var setStateToStorage = function(state) {
    Storage.session.setItem(LOGGED_OUT_SIGN_UP_SNACKBAR_STATE, state);
};
export var useSignUpSnackbarStateMachine = function() {
    var _useState = _sliced_to_array(useState(function() {
        return getStateFromStorage() === SignUpSnackbarState.DISPLAYABLE;
    }), 2), isDisplayable = _useState[0], setIsDisplayable = _useState[1];
    var updateSignUpSnackbarState = useCallback(function(eventType) {
        notifySignupSnackbarEvent(eventType);
        setIsDisplayable(getStateFromStorage() === SignUpSnackbarState.DISPLAYABLE);
    }, []);
    useEffect(function() {
        var _getWindow;
        var timeoutId = undefined;
        var handleScroll = function() {
            if (getStateFromStorage() === SignUpSnackbarState.POST_AUTO_SIGNUP) {
                timeoutId = setTimeoutIfPossible(function() {
                    updateSignUpSnackbarState(SignUpSnackbarEvent.TIMEOUT_ELAPSED);
                }, TIME_UNTIL_DISPLAY);
            }
        };
        (_getWindow = getWindow()) === null || _getWindow === void 0 ? void 0 : _getWindow.addEventListener("scroll", handleScroll);
        return function() {
            var _getWindow;
            (_getWindow = getWindow()) === null || _getWindow === void 0 ? void 0 : _getWindow.removeEventListener("scroll", handleScroll);
            clearTimeout(timeoutId);
        };
    }, [
        updateSignUpSnackbarState
    ]);
    return {
        isSignUpSnackbarDisplayable: isDisplayable,
        updateSignUpSnackbarState: updateSignUpSnackbarState
    };
};
export var notifySignupSnackbarEvent = function(eventType) {
    var state = getStateFromStorage();
    if (state === SignUpSnackbarState.DISMISSED) {
        return;
    }
    switch(eventType){
        case SignUpSnackbarEvent.AUTO_SIGNUP_OPENED:
            setStateToStorage(SignUpSnackbarState.PRE_AUTO_SIGNUP);
            break;
        case SignUpSnackbarEvent.AUTO_SIGNUP_CLOSED:
            if (state === SignUpSnackbarState.PRE_AUTO_SIGNUP) {
                setStateToStorage(SignUpSnackbarState.POST_AUTO_SIGNUP);
            }
            break;
        case SignUpSnackbarEvent.TIMEOUT_ELAPSED:
        case SignUpSnackbarEvent.NAVIGATED:
            if (state === SignUpSnackbarState.POST_AUTO_SIGNUP) {
                setStateToStorage(SignUpSnackbarState.DISPLAYABLE);
            }
            break;
        case SignUpSnackbarEvent.DISMISSED:
            setStateToStorage(SignUpSnackbarState.DISMISSED);
            break;
        default:
            exhaustiveSwitchWithDefault()(eventType);
    }
};
